<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar, surveyTheme}">
    <notifications></notifications>
    <slot name="sidebar"></slot>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar v-if="showNavbar" :title="title" :hasSidebar="true"></dashboard-navbar>
      <router-view name="header"></router-view>
      <div
        :class="{ content: !$route.meta.hideContent, 'content-no-navbar': !showNavbar }"
        @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view @nav="handleNav"></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="showFooter"></content-footer>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from './HspNavbar.vue';
import ContentFooter from './HspFooter.vue';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    ZoomCenterTransition
  },
  props: {
    showNavbar: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      sidebarBackground: 'primary' //vue|blue|orange|green|red|primary,
    };
  },
  computed: {
    surveyTheme() {
      let theme = this.$store.getters.themeColor(this.$route.params.surveyId);

      if(theme !== null) {
        return `${theme}-theme`;
      }

      return null;
    }
  },
  methods: {
    handleNav(type) {
      window.scrollTo(0,0);
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.content-no-sidebar {
  padding-left: 30px !important;
}

.content-no-navbar {
  padding-top: 30px !important;
}
</style>
